export default [
  {
    name: "DirectorPortal",
    path: "/directorPortal",
    component: () => import("@/views/directorPortal/index.vue"),
    children: [
      {
        name: "DPFileManagement",
        path: "/directorPortal/file-management",
        component: () =>
          import("@/views/directorPortal/fileManagement/index.vue"),
        meta: {
          title: "文件上传",
        },
      },
      {
        name: "DPMeetingBrief",
        path: '/directorPortal/meeting-brief',
        component: () => import('@/views/directorPortal/meetingBrief/list.vue'),
        meta: {
          title: '会议纪要'
        }
      },
      {
        name: 'DPManagementTeamConfig',
        path: '/directorPortal/management-team-config',
        component: () => import('@/views/directorPortal/managementTeamConfig/list.vue'),
        meta: {
          title: '管理层配置'
        },
      },
      {
        name: 'DPAnnualEvent',
        path: '/directorPortal/annual-event',
        component: () => import('@/views/directorPortal/annualEvent/list.vue'),
        meta: {
          title: '年度事项'
        }
      }
    ],
  },
];
